import { Component } from '@angular/core';

@Component({
  selector: 'era-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.scss'],
})
export class PanelComponent {}
